import { AbsoluteCenter, Box } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import TextareaAutosize from 'react-textarea-autosize';

import classNames from 'classnames/bind';
import { useColorMode } from 'shared';

import { CHAT_FORM_FIELD_NAMES } from 'features/chat/config';
import { ChatFormValues } from 'features/chat/config/types/ChatForm';

import styles from '../Chat.module.css';

type ChatFormTextInputProps = {
  handleKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  children?: React.ReactNode;
};

const cx = classNames.bind(styles);

export const ChatFormTextInput = ({
  handleKeyDown,
  children,
}: ChatFormTextInputProps) => {
  const { register } = useFormContext<ChatFormValues>();
  const { colorMode } = useColorMode();

  const isThemeLight = colorMode === 'light';

  return (
    <Box position="relative" w="100%">
      <TextareaAutosize
        placeholder="Message"
        className={cx(
          'chat__input',
          'chat__input--white',
          `${!isThemeLight ? 'chat__input--dark' : ''}`
        )}
        maxRows={3}
        onKeyDown={handleKeyDown}
        {...register(CHAT_FORM_FIELD_NAMES.TEXT, {
          required: true,
          setValueAs: (v) => v.trim(),
        })}
      />
      <AbsoluteCenter right={0.5} axis="vertical">
        {children}
      </AbsoluteCenter>
    </Box>
  );
};
